import { createContext, useContext } from 'react';

interface SearchResultsSeoContextValues {
  title: string;
  description: string;
  canonicalUrl: string;
  imageUrl?: string;
  noIndex: boolean;
}

const SEARCH_RESULTS_SEO_CONTEXT_DEFAULT_VALUES: SearchResultsSeoContextValues = {
  title: 'The Best Wedding Vendors - Zola',
  description:
    'Find the best wedding vendors. See prices, photos and availability for your special day.',
  canonicalUrl: '',
  imageUrl: undefined,
  noIndex: false,
};

export const SearchResultsSeoContext = createContext<SearchResultsSeoContextValues>(
  SEARCH_RESULTS_SEO_CONTEXT_DEFAULT_VALUES
);

export const useSearchResultsSeoContext = () => {
  const context = useContext(SearchResultsSeoContext);
  if (context === undefined) {
    throw new Error('useSearchResultsSeoContext must be used within a SearchResultsSeoProvider');
  }
  return context;
};
